module.exports = __webpack_public_path__ + "img/blindreceive.0b4dcf39.png";